export enum PreviewDevice {
  Desktop = 'desktop',
  Phone = 'phone',
  Tablet = 'tablet'
}

export const PreviewDevices: Record<PreviewDevice, { width: number; height: number; cssClass: string }> = {
  [PreviewDevice.Desktop]: {
    width: 1100,
    height: 700,
    cssClass: 'desktop'
  },
  [PreviewDevice.Phone]: {
    width: 400,
    height: 700,
    cssClass: 'phone'
  },
  [PreviewDevice.Tablet]: {
    width: 568,
    height: 700,
    cssClass: 'tablet'
  }
};
